import { strCode } from "../../../../../consts";

export const lablesInfoConfig = {
  updated: strCode.UPDATED_LABEL_INFO,
  inProgress: strCode.IN_PROGRESS_LABEL_INFO,
  queued: strCode.QUEUED_LABEL_INFO,
  canceled: strCode.CANCELED_LABEL_INFO,
  removed: strCode.REMOVED_LABEL_INFO,
  rejected: strCode.REJECTED_LABEL_INFO,
  failed: strCode.FAILED_LABEL_INFO,
  neverAttempted: strCode.NEVER_ATTEMPTED_LABEL_INFO
};
